var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"full-screen-overlay",class:{'full-screen-overlay--init': _vm.initializing}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }